import { CheckCircle } from 'lucide-react';

export default function RunningStrip() {
    const features = [
        "Fast Shipping",
        "Custom Parts Sourcing Available",
        "24/7 Customer Support",
        "Certified OEM Components",
        "Quick Turnaround Times",
        "Trusted by Leading Contractors",
    ];

    return (
        <div className="w-full overflow-hidden bg-orange-500 h-5 sm:h-6 md:h-7 relative">
            <div className="flex w-max animate-marquee">
                {/* First copy */}
                <div className="flex gap-5">
                    {features.map((feature, idx) => (
                        <div
                            key={idx}
                            className="flex items-center gap-1 text-white font-semibold text-[14px] sm:text-sm md:text-base flex-shrink-0 px-4"
                        >
                            <CheckCircle size={14} className="text-white" />
                            <span>{feature}</span>
                        </div>
                    ))}
                </div>

                {/* Second copy for seamless scroll */}
                <div className="flex gap-5">
                    {features.map((feature, idx) => (
                        <div
                            key={"copy-" + idx}
                            className="flex items-center gap-1 text-white font-semibold text-[14px] sm:text-sm md:text-base flex-shrink-0 px-4"
                        >
                            <CheckCircle size={14} className="text-white" />
                            <span>{feature}</span>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 20s linear infinite;
        }
      `}</style>
        </div>
    );
};
